import { render, staticRenderFns } from "./AssistantStatus.vue?vue&type=template&id=05c79db2&"
import script from "./AssistantStatus.vue?vue&type=script&lang=js&"
export * from "./AssistantStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports